module.exports = __webpack_public_path__ + "img/menu-format1.88b89d56.jpg";